<script setup lang="ts">
  import { MpCard, MpText, useMpScreen } from '@borg/ui';

  withDefaults(
    defineProps<{
      showLink?: boolean;
    }>(),
    {
      showLink: false,
    },
  );

  const { isMobile } = useMpScreen();
  const job = jobRepository.use();
  const organizationCard = useOrganizationCard.inject();
  const projectConfig = useProjectConfig();
  const alwaysShowLink = projectConfig.name === 'vrabotuvanjemk';
</script>

<template>
  <MpCard
    v-if="organizationCard.organization"
    :p="isMobile ? 'md' : 'lg'"
    border
    shadow
    class="organization-card"
  >
    <OrganizationLogo extra-large />
    <MpText
      as="h6"
      no-margin
      class="organization-card__name"
    >
      {{
        organizationCard.organization === 'incognito'
          ? $t('ORGANIZATION_INCOGNITO')
          : organizationCard.organization.name
      }}
    </MpText>
    <template v-if="organizationCard.organization !== 'incognito'">
      <LinksLocale
        v-if="organizationCard.organization.web"
        :to="organizationCard.organization.web"
        target="_blank"
      >
        <MpText
          link
          semibold
          class="organization-card__web"
        >
          {{ organizationCard.organization.web }}
        </MpText>
      </LinksLocale>
      <MpText
        v-if="organizationCard.organization.address"
        semibold
        no-margin
      >
        {{ organizationCard.organization.address }}
      </MpText>
      <MpText
        v-if="organizationCard.organization.phone"
        semibold
        no-margin
      >
        {{ organizationCard.organization.phone }}
      </MpText>
      <MpText
        v-if="!job?.isDesigned && organizationCard.organization.info"
        type="body2"
        no-margin
      >
        {{ handleNewline(organizationCard.organization.info) }}
      </MpText>
      <LinksLocale
        v-if="showLink && (organizationCard.organization.hasProfile || alwaysShowLink)"
        :to="{
          name: 'employers-employerId',
          params: { employerId: organizationCard.organization.id },
        }"
      >
        <MpText
          link
          semibold
        >
          {{ $t('ORGANIZATION_CARD.MORE_ABOUT_EMPLOYER_BUTTON_LABEL') }}
        </MpText>
      </LinksLocale>
      <OrganizationFollow
        v-if="projectConfig.features.organizationFollow"
        :id="organizationCard.organization.id"
      />
      <OrganizationBadges />
    </template>
  </MpCard>
</template>

<style scoped lang="scss">
  .organization-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--mp-space-50);

    &__logo {
      max-width: 280px;
      max-height: 140px;
      object-fit: contain;
      width: fit-content;
      height: fit-content;
    }

    &__name {
      text-align: center;
    }

    &__web {
      word-break: break-word;
    }
  }
</style>
